// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import { trimCommas } from '../../../../utils/commonUtils';

export default class ShowView extends JQueryView {
  cloneFileElement = {};

  constructor() {
    super('.info-container');

    $('.form-group-float').each((index, element) => {
      const control = $(element).find('.form-control');
      if (control.val().length !== 0) {
        control.addClass('form-control-active');
      } else {
        control.removeClass('form-control-active');
      }
    });
  }

  @on({ event: 'click', selector: 'input[type="submit"]' })
  trimCommasFromValue() {
    $('.currency').each(function() {
      const input = $(this);
      input.val(trimCommas(input.val()));
    });
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
    }
  }

  @on({ event: 'blur input', selector: '.form-group-float, .form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      target.removeClass('form-control-active');
    } else {
      target.addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
    }
  }

  @on({ event: 'change', selector: 'input, select' })
  changeInput() {
    this.replaceCancelButton();
  }

  @on({ event: 'click', selector: '.cancel-button, #cancel_btn' })
  onClickCancelButton(event: any) {
    event.preventDefault();

    $('.edit-button').removeClass('edit-button-disable');
    $('.menu').removeClass('edit-button-disable');
    $('.add-category-button').removeClass('edit-button-disable');

    if ($('#cancel_modal').is(':visible')) {
      $('#cancel_modal').modal('hide');
    }
    $('.show:hidden').removeClass('d-none');
    $('.info-form').remove();
  }

  @on({ event: 'click', selector: '.edit-button, .add-category-button' })
  onClickEditButton(event: any) {
    $('.edit-button')
      .not(event.target)
      .addClass('edit-button-disable');
    $('.menu').addClass('edit-button-disable');
    $('.add-category-button').addClass('edit-button-disable');
  }

  @on({ event: 'click', selector: '.js-remove-button' })
  onClickRemoveFields(event: any) {
    const _destroy = $(event.target)
      .parents('fieldset')
      .find('._destroy');
    _destroy.val('1');
    _destroy.closest('fieldset').hide();
    event.preventDefault();
    this.renderInputArea(event);
    this.replaceCancelButton();
  }

  @on({ event: 'click', selector: '.js-add-area' })
  onClickAddBoardMemberFields(event: any) {
    this.addFields(event);
    this.renderInputArea(event);
    this.replaceCancelButton();
  }

  addFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $('.add-items-wrapper').append(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
  }

  renderInputArea(event: any) {
    const $addButton = $(event.target)
      .parents('.info-form')
      .find('.js-add-area');

    if ($(event.target).hasClass('--boardMember')) {
      if ($('#board-member-wrapper fieldset:visible').length >= 20) {
        $addButton.hide();
      } else {
        $addButton.show();
      }
    } else if ($(event.target).hasClass('--ownItem')) {
      if ($('#own-categories-wrapper fieldset:visible').length >= 5) {
        $addButton.hide();
      } else {
        $addButton.show();
      }
    }
  }

  replaceCancelButton() {
    const $cancelButton = $('.cancel-button');
    const newButton = $(
      '<button type="button" class="btn btn-outline-link" data-toggle="modal" data-target="#cancel_modal">キャンセル</button>',
    );
    $cancelButton.replaceWith(newButton);
  }
}
